import { postCheckout } from 'api/checkoutpage';
import { useMutation } from 'react-query';
import axios, { AxiosError } from 'axios';
import { usePopup } from 'context/PopupContext/PopupContext';

export const useCheckoutMutation = () => {
  const { showPopup } = usePopup();
  const { mutate, status, isError } = useMutation(postCheckout, {
    onSuccess: (data) => {
      window.location.replace(data.paymentLink);
    },

    onError: (e: AxiosError | Error) => {
      console.error('Error:', e);
      if (axios.isAxiosError(e)) {
        showPopup({
          message: e.response?.data?.message || e.message,
          type: 'ERROR',
        });
      }
    },
  });

  return {
    mutate,
    isError,
    status,
  };
};
